import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { discountMobx } from 'restaurant'
import { memberMobx } from '@mobxStore'
import { checkExpire } from '@utils'
import { checkMCBenifit } from 'common/utils/member'
import { classNames, format, ddayjs, toPrice } from '@dt/fe-utils'
import cardBg from '@img/member/card-bg.png'
import './index.scss'

interface IProps {
  type?: string; // 来源类型 mall 商城
  disabled?: boolean; // 是否可选
  cardInfo: any;
  onUse?: (data: any) => void;
}

const CardItem: FC<IProps> = (props: IProps) => {
  const { cardInfo, onUse, type, disabled } = props
  const memberCardInfo = type === 'mall' ? memberMobx.mallCardInfo : memberMobx.cardInfo
  const discountType = type === 'mall' ? cardInfo.card.mallDiscountType : cardInfo.card.discountType
  const discountValue = type === 'mall' ? cardInfo.card.mallDiscountValue : cardInfo.card.discountValue
  const switchCard = () => {
    if (disabled) return
    if (memberCardInfo && memberCardInfo.memberCardId === cardInfo.memberCardId) return
    // if (checkTime()) return
    if (type === 'mall') {
      memberMobx.setMallCardInfo(cardInfo)
    } else {
      discountMobx.deleteOnlyBalancePay()
      memberMobx.setCardInfo(cardInfo)
    }
    onUse && onUse(cardInfo)
  }
  const checkTime = () => {
    const isExpire: boolean = cardInfo.expireTime === null ? false : checkExpire(cardInfo.expireTime, ddayjs().format('YYYY-MM-DD HH:mm:ss'))
    return isExpire
  }
  const { benifitRecharge, benifitMealPrice, benifitMealRate, benifitCoupon } = checkMCBenifit(cardInfo?.card || {}, cardInfo?.balance)
  return (
    <div
      className={classNames('use-card-item', { disabled: disabled })}
      data-cypid={`useCardItem_${cardInfo?.memberCardId}`}
      onClick={switchCard} style={{
        color: cardInfo.card.extra.fontColor || '#ffffff'
      }}
    >
      <div className='mci-content' style={{ backgroundImage: `url(${cardInfo.card.cover || cardBg})` }}>
        <div className='mcip-header'>
          <div className='name'>
            <span>{cardInfo.card.cardName}</span>
          </div>
          <div className='content-detail'>
            {
              benifitRecharge
                ? (
                  <>
                    <span className='split-line'>|</span>
                    <span className='number'>{toPrice(cardInfo.balance || 0)}</span>
                    <span className='split-line'>|</span>
                    <span className='integral'>{i18n.t('mkt.common.integral')}{cardInfo.integral || 0}</span>
                  </>) : ''
            }
            {
              !cardInfo.card.allowAgainLoad && !cardInfo.card.allowCustomizeLoad &&
                <>
                  <span className='split-line'>|</span>
                  <span className='integral'>{i18n.t('mkt.member.noRecharge')}</span>

                </>
            }
            {benifitMealPrice && (
              <>
                <span className='split-line'>|</span>
                <span className='equity-item'>{i18n.t('checkout.memberPrice')}</span>
              </>
            )}
            {
              benifitMealRate &&
                <>
                  <span className='split-line'>|</span>
                  <span className='equity-text equity-item'> {i18n.t('mkt.common.equity')}</span>
                  <span>{format.toDiscount('discountRate', discountValue)}</span>
                </>
            }
            {benifitCoupon && (
              <>
                <span className='split-line'>|</span>
                <span className='equity-text equity-item'> {i18n.t('mkt.member.couponSend')}</span>
              </>
            )}
            <span className='detail'>
              {checkTime() && <span className='expire-text'>{i18n.t('mkt.member.expired')}</span>}
            </span>
          </div>
        </div>
      </div>
      <div className='mcip-footer'>
        <div className='use-tip'>
          <i className={classNames('iconfont', (memberCardInfo && memberCardInfo.memberCardId === cardInfo.memberCardId) ? 'icon-checked' : 'no-select')} />
        </div>
      </div>
    </div>
  )
}

export default observer(CardItem)
